import { useCallback, useEffect } from 'react';

export type UseBodyScrollLock = () => {
  lock: () => void;
  unlock: (scrollToTop?: boolean) => void;
};

export const useBodyScrollLock: UseBodyScrollLock = () => {
  const lock = useCallback(() => {
    document.body.style.left = `-${window.scrollX}px`;
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = 'fixed';
  }, []);

  const unlock = useCallback((scrollToTop = false) => {
    const left = document.body.style.left;
    const top = document.body.style.top;
    document.body.style.left = '';
    document.body.style.top = '';
    document.body.style.position = '';
    window.scrollTo(
      scrollToTop ? 0 : parseInt(left || '0') * -1,
      scrollToTop ? 0 : parseInt(top || '0') * -1,
    );
  }, []);

  useEffect(() => {
    return () => {
      unlock();
    };
  }, [unlock]);

  return {
    lock,
    unlock,
  };
};
